<template>

</template>

<script>
export default {
    data() {
        return {
            sid: ""
        };
    },
    created() {
        this.sid = this.$route.query.sid;
        var isH5 = true;
        if (isH5) {
            location.href = window.GLOBAL_CONFIG.APP_H5_URL + "unifysign/sign" + "?sid=" + this.sid;
        } else {
            this.$router.replace({
                path: "/unifysign/sign",
                sid: this.sid
            })
        }


    },
    methods: {


    },
};
</script>

